export default __webpack_public_path__ + "static/media/bridge-large.4ccc5187.jpg";